// extracted by mini-css-extract-plugin
module.exports = {"root":"Label--root--6ojSc","required":"Label--required--1H4Ds"};